import { get, post } from "../../helpers/utils/http-client";
import { API_PREFIX } from '../../consts/api-endpoints';

export async function getAuthConfig(appId, authConnector, accessKey) {
    try {
        const resp = await get(`${API_PREFIX}/apps/${appId}/model/auth/${authConnector}`, {} ,{ 'Authorization': accessKey });
        const { response, status } = resp;
        if (status !== 200) {
            return null;
        }
        return response;
    } catch (err) {
        console.debug('getAuthConfig failed cause', err.message, err.code);
        return null;
    }
}

export async function getUserInfo(userInfoEndpoint, accessToken) {
    try {
        const resp = await get(`${userInfoEndpoint}`, {} ,{ 'Authorization': `Bearer ${accessToken}` });
        const { response, status } = resp;
        if (status !== 200) {
            return null;
        }
        return response;
    } catch (err) {
        console.debug('getUserInfo failed cause', err.message, err.code);
        return null;
    }
}

export async function workflowResume(appId, request, accessKey) {
    try {
        const resp = await post(`${API_PREFIX}/apps/${appId}/runtime/workflow/resume`, request ,{ 'Authorization': accessKey });
        const { response, status } = resp;
        if (status !== 200) {
            return null;
        }
        return response;
    } catch (err) {
        console.debug('setAuthContext failed cause', err.message, err.code);
        return null;
    }
}